import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import ProfileMeta from 'profile/components/profile_meta';

export default connect(mapProfileToProps)(ProfileMeta);



// WEBPACK FOOTER //
// ./profile/containers/profile_meta.js